<template>
    <v-dialog
        v-model="show"
        width="unset"
        max-width="700"
        tabindex="-1"
        role="dialog"
        aria-labelledby="TransferModal"
        aria-hidden="true"
        transition="v-expand-y-transition"
        @click:outside="close"
    >
        <loading-overlay
            absolute
            :loading="loading"
        />
        <v-card
            transition="v-expand-y-transition"
            class="elevation-12 rounded-xl invoice-card"
            width="89vw"
            max-width="450px"
            :loading="loading && 'white'"
        >
            <v-toolbar dark flat color="white" v-if="invoiceModalTitle">
                <v-btn color="black" icon @click="currentStep -= 1">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-spacer />
                <v-toolbar-title class="primary--text font-weight-bold pa-0">
                    {{ invoiceModalTitle }}
                </v-toolbar-title>
                    <v-spacer />
                <div></div>
            </v-toolbar>

            <v-card
                class="elevation-12 mb-4"
                :class="{ 'px-6': !showDashboard }"
                :loading="loading && 'white'"
                id="scroller"
                style="height: 75vh"
                v-if="currentStep < 3"
            >
                <template v-if="currentStep === 1">
                    <home
                        v-if="!showDashboard"
                        @create="currentStep += 1"
                        :invoiceStats="invoiceStats"
                        @show="showDashboard = true"
                    />
                    <dashboard
                        v-else
                        :invoiceStats="invoiceStats"
                        @close="showDashboard = false"
                    />
                </template>
                <recipient-form
                    v-else-if="currentStep === 2"
                    :recipient="selectedRecipient"
                    @proceed="setRecipient"
                    :loading.sync="loading"
                />
            </v-card>
            <invoice-details
                v-else-if="currentStep === 3"
                @edit="currentStep = 2"
                :recipient="selectedRecipient"
                :invoice="invoiceDetails"
                @proceed="setInvoiceDetails"
            />
            <invoice-preview
                v-else-if="currentStep === 4"
                :invoice="invoiceDetails"
                @send="sendInvoice"
                @edit="currentStep = 3"
            />
        </v-card>
    </v-dialog>
</template>

<script>
import Home from './components/home.vue';
import Dashboard from './components/dashboard.vue';
import RecipientForm from './components/recipient-form.vue';
import InvoiceDetails from './components/invoice-details.vue';
import InvoicePreview from './components/invoice-preview.vue';

export default {
    props: {
        show: Boolean,
    },
    components: {
        Home,
        RecipientForm,
        Dashboard,
        InvoiceDetails,
        InvoicePreview,
    },
    data() {
        return {
            currentStep: 1,
            showDashboard: false,
            loading: false,
            selectedRecipient: null,
            invoiceDetails: null,
            invoiceStats: [
                {
                    number: 5,
                    title: 'Unpaid',
                    color: '#FF9791',
                },
                {
                    number: 3,
                    title: 'Processing',
                    color: '#f8ac8c',
                },
                {
                    number: 10,
                    title: 'Paid',
                    color: '#8eedd1',
                },
            ],
        }
    },
    computed: {
        invoiceModalTitle() {
            if(this.currentStep === 2) return 'Create new invoice';
            else if(this.currentStep === 3) return 'Invoice Details';
            else if(this.currentStep === 4) return 'Invoice Preview';

            return null;
        },
    },
    methods: {
        setRecipient(recipient) {
            this.selectedRecipient = recipient;
            this.loading = true;

            setTimeout(() => {
                this.loading = false;
                this.currentStep = 3;
            }, 3000);
        },
        setInvoiceDetails(details) {
            this.invoiceDetails = details;
            this.currentStep = 4;
        },
        sendInvoice() {
            // send mail
            console.log('mail sent')
            this.close();
        },
        close() {
            this.$emit('update:show', false);
        },
    },
}
</script>

<style scoped>
.v-dialog.v-dialog--active {
    background: transparent !important;
}

.invoice-card {
    overflow: hidden;
}

.invoice-card >>> .v-toolbar {
    position: sticky;
    top: 0;
    z-index: 9;
    border-bottom: 2px solid rgba(0, 0, 0, 0.25) !important;
}

.invoice-card #scroller {
    max-height: 600px;
    height: 70vh;
    box-shadow: none !important;
    overflow-y: auto;
}
</style>